
/** vendor */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SearchIcon } from '@heroicons/react/solid'
import { XIcon } from '@heroicons/react/outline'

/** components */
import SearchSelectForm from '../SearchSelectForm'
import IngredientListItem from './IngredientListItem'

export default function CreateIngredientsForm({onUpdate, recipe}) {
    const ingredientOptions = useSelector(state => state.form_options?.ingredient_options)
    
    const [selectedIngredients, setSelectedIngredients] = useState([])
    const [focusIngredientSelection, setFocusIngredientSelection] = useState(false)

    /**
     * Utils
     */
    const addRecipeIngredient = (ingredient) => {
        if (ingredient) {
            const selectedIngredientsCopy = [...selectedIngredients]
            let matched = false

            selectedIngredientsCopy.map((i) => {
                if (ingredient.value === i.value) {
                    matched = true
                    i['quantity']++
                }
                return i
            })

            if (!matched) {
                ingredient['quantity'] = 1
                selectedIngredientsCopy.push(ingredient)
            }

            setSelectedIngredients(selectedIngredientsCopy)
            onUpdate({ingredients: selectedIngredientsCopy})
        }
    }

    /**
     * Hooks
     */
    useEffect(() => {
        if (recipe?.ingredients) {
            setSelectedIngredients(recipe?.ingredients)
        }
    }, [recipe])

    /**
     * Handlers
     */
    const handleOnRemoveIngredient = (ingredient) => {
        const selectedIngredientsCopy = [...selectedIngredients]
        const indegredientIndex = selectedIngredientsCopy.indexOf(ingredient)
       
        selectedIngredientsCopy.splice(indegredientIndex, 1)
        setSelectedIngredients(selectedIngredientsCopy)
        onUpdate({ingredients: selectedIngredientsCopy})
    }

    const handleOnSelectItem = (index, option) => {
        if(option) {
            addRecipeIngredient(option)
        }
    }

    const handleDismissRecipeSelector = (e) => {
        setFocusIngredientSelection(false)
    }

    return (
        <div className="pb-14 w-full px-2"> 
            <ul role="list" className="flex-grow min-w-full">
                {                        
                    selectedIngredients ? 
                        selectedIngredients.map((ingredient, index) => { return (
                            <li className="min-w-full odd:bg-an_white-dark px-2" key={index}>
                                <IngredientListItem
                                    ingredient={ingredient} 
                                    onRemove={ (ingredient) => { handleOnRemoveIngredient(ingredient) } } 
                                />
                            </li>
                        )}).reverse() : <li>none.</li>
                }
            </ul>

            <div 
                className="border rounded-b-sm border-an_green-dark py-2 bg-an_white-dark  absolute bottom-0 left-2"
                style={{ width: 'calc(100% - 1rem)' }}
            >
                <button 
                    className={`block mx-auto px-5 py-2 rounded p-2 w-56 border border-an_orange-darker3 text-an_white bg-an_orange text-border-orange`}
                    onClick={() => { setFocusIngredientSelection(true) }}
                >
                    add ingredients
                </button>
            </div>

            {
                focusIngredientSelection ?
                    <div className="fixed bg-black bg-opacity-30 bottom-0 left-0 w-screen h-screen flex justify-center items-end z-50">
                        <div className="w-full">
                            {
                                focusIngredientSelection &&      
                                    <button
                                        className="rounded z-50 w-8 h-8 mr-2 bg-an_green-dark text-an_white block ml-auto"
                                        onClick={(e) => { handleDismissRecipeSelector(e) }}
                                    >
                                        <XIcon className="w-6 h-6 block mx-auto" />
                                    </button>
                            }
                            <SearchSelectForm 
                                label="Search Ingredients"
                                options={ingredientOptions} 
                                selectedOptions={selectedIngredients}
                                onSelectItem={(index, option) => { handleOnSelectItem(index, option) }}
                                handleOnSelectSearchFocus={(newValue) => { }}
                                showOptions={true}
                            />
                        </div>
                        
                    </div> : ''     
            }
        </div>
    )
}

